import { Component } from "react";
import ButtonIcon from "../../../button";
import { CustomColumns } from "../../modal-popover/custom-columns";
import CustomDropdownButton from "../../custom-form/custom-dropdown-button.component";
class TableWithExtractSearchLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
             selectedIndex: "0",
             updatedDisplaySearch: false
        };
    }

     DisplaySearhBox() {
        this.setState(prevState => {
            const updatedDisplaySearch = !prevState.displaySearch;
            this.props.displaySearchBox(updatedDisplaySearch);
            return {displaySearch: updatedDisplaySearch};
        });
    }

    render() {
        const { isReadOnly, isReadAndExtractOnly, isReadAndWrite, isViewing, multipleOption, 
                onSelect=()=>{}, buttonIcon=null, extractListLabel='', options=[] } = this.props;
        return (
            <div className="history-main-container">
                
                <div className="button-header__alignment">
                    <ButtonIcon isDisable={isViewing ? true : false} onClick={this.DisplaySearhBox.bind(this)} iconLeft="file-magnifying-glass" iconSize="17px" customClassName="header-option-list header-filter-button" labelName="Search"/>
                    {!this.props.listHistoryTab && !this.props.hideCustomColumn ? <CustomColumns 
                            firstList={this.props.firstList ? this.props.firstList : []} 
                            secondList={this.props.secondList ? this.props.secondList : []} 
                            defaultList={this.props.defaultList ? this.props.defaultList :[]} 
                            saveAction={this.props.saveAction}/> : null }
                        {
                            multipleOption ?
                                <CustomDropdownButton 
                                    onSelect={onSelect} 
                                    buttonIcon={buttonIcon} 
                                    extractListLabel={extractListLabel} 
                                    options={options}
                                    isDisable={isViewing ? true : false}
                                />
                            :
                                <ButtonIcon
                                    onClick={(isReadAndExtractOnly || isReadAndWrite) ? () => this.props.extractAction() : () => { }}
                                    iconLeft="cloud-arrow-down" iconSize="17px"
                                    customClassName={`${!this.props.isReadOnly ? "header-option-list" : ""} header-filter-button`}
                                    isDisable={isViewing || (isReadOnly && !isReadAndExtractOnly && !isReadAndWrite)}
                                    labelName="Extract List"
                                /> 
                        }
                        
                        
                </div> 
                {this.props.children}
            </div>
        );
    }
}

export default TableWithExtractSearchLayout;